<template>

      <div >
         <div class="row">
            <div class="w-100"> 
            
            <!-- <div class="d-flex align-items-center justify-content-between pr-4 pl-2">
              <div class="color-default px-2 font-weight-bold text-capitalize mt-3 py-2"> {{formData.report.title}} </div>
              <div class="color-default px-2 font-weight-bold text-capitalize mt-3 py-2 text-right">  {{ formData.report.first_name + ' ' + formData.report.last_name }} </div>
            </div> -->

             <div  class="d-flex justify-content-between align-items-center mx-auto py-2" style="border-bottom:1px solid rgba(0, 0, 0, 0.1); gap:5px;color:rgb(66, 64, 64);" v-for="progress in JSON.parse(formData.report.task_details)" :key="progress.id" >
                   <div class="col-8">
                   <div class="d-flex align-items-center justify-content-start">
                    <div class="listDot mr-1"></div>
                    <span class="py-2 color-default font-weight-bold"> Worked on {{ progress.title }} for {{ progress.hours }} hour </span>
                  
                   </div>
                   </div>
                    <div class="col-3 d-flex justify-content-end color-default font-weight-bold"> {{formData.report.report_date | createdFormateData }}</div>
                <br>
                </div> 
            </div>
         </div>
    </div>
		</div>
        </template>
        <script>
	import axios from 'axios';
	import moment from 'moment';
    import Vue from 'vue';

    Vue.filter('createdFormateData', function (value) {
		if (value != '0000-00-00 00:00:00' && value != null) {
			return moment(String(value)).format('MMM DD, Y')
		}
	})
    export default {
		props: [
			'action', 'formData'
		],
		data: function () {
			return {
				
			};
		},
    
    }
    </script>

    <style>
      .listDot{
        width:5px;
        height: 5px;
        background: #48a6a6;
        border-radius:50%;
      }
    </style>